"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StaffModeConfig = void 0;
var _react = _interopRequireDefault(require("react"));
var _staffExcessOptionsDetails = require("./staffExcessOptionsDetails");
var _staffExcessSelectionScript = require("./staffExcessSelectionScript");
var _staffGapOnlyScript = require("./staffGapOnlyScript");
var _staffRoutineCareAddOnScript = require("./addons/staffRoutineCareAddOnScript");
var _staffDentalAddOnScript = require("./addons/staffDentalAddOnScript");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/* eslint-disable max-len */

var StaffModeConfig = exports.StaffModeConfig = {
  excess: {
    preQuestion: function preQuestion(_ref) {
      var plan = _ref.plan;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "staffInstructionsPanel"
      }, /*#__PURE__*/_react["default"].createElement(_staffExcessOptionsDetails.StaffExcessOptionsDetails, {
        plan: plan
      }));
    },
    postQuestion: function postQuestion(_ref2) {
      var plan = _ref2.plan;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "staffInstructionsPanel"
      }, /*#__PURE__*/_react["default"].createElement(_staffExcessSelectionScript.StaffExcessSelectionScript, {
        plan: plan
      }));
    }
  },
  routineCare: {
    preQuestion: function preQuestion(_ref3) {
      var plan = _ref3.plan;
      return /*#__PURE__*/_react["default"].createElement(_staffRoutineCareAddOnScript.StaffRoutineCareAddOnScript, {
        plan: plan
      });
    }
  },
  dental: {
    preQuestion: function preQuestion(_ref4) {
      var plan = _ref4.plan;
      return /*#__PURE__*/_react["default"].createElement(_staffDentalAddOnScript.StaffDentalAddOnScript, {
        plan: plan
      });
    }
  },
  gapOnly: {
    postQuestion: function postQuestion(_ref5) {
      var plan = _ref5.plan;
      return /*#__PURE__*/_react["default"].createElement(_staffGapOnlyScript.StaffGapOnlyScript, null);
    }
  }
};
var _default = exports["default"] = {
  StaffModeConfig: StaffModeConfig
};